import {
	Instance,
	SnapshotIn,
	applySnapshot,
	flow,
	getParent,
	getSnapshot,
	types,
} from 'mobx-state-tree';

import { putUsersQuizSlides } from '@common/api/users';

import UserAnswerItem from '../Answers/UserAnswerItem';
import { IUserQuizzesModel } from '../Onboarding/UserQuizzes';

const SlideUserItem = types
	.model('SlideUserItem', {
		id: types.optional(types.number, 0),
		onboarding_quiz_id: types.maybeNull(types.number),
		title: types.maybeNull(types.string),
		text: types.maybeNull(types.string),
		answer_type: types.maybeNull(types.string),
		answers_side: types.maybeNull(types.string),
		sort_id: types.maybeNull(types.number),
		is_final: types.maybeNull(types.boolean),
		created_at: types.maybeNull(types.string),
		updated_at: types.maybeNull(types.string),
		deleted_at: types.maybeNull(types.string),
		is_completed: types.maybeNull(types.boolean),
		background_url: types.maybeNull(types.string),
		image_url: types.maybeNull(types.string),
		answer_options: types.optional(types.array(UserAnswerItem), []),
		text_answer: types.maybeNull(types.string),
		step_id: types.maybeNull(types.number),
		is_required: types.maybeNull(types.union(types.boolean, types.number)),
	})
	.volatile(() => ({
		loading: false,
	}))
	.actions((self) => ({
		save: flow(function* (data: number[] | string) {
			self.loading = true;
			try {
				yield putUsersQuizSlides({
					onboarding_quiz_slide_id: self.id,
					is_completed: true,
					...(Array.isArray(data)
						? {
								selected_answer_option_ids: data,
							}
						: {
								selected_answer_option_ids: [],
								text_answer: data,
							}),
				});

				applySnapshot(self, {
					...getSnapshot(self),
					is_completed: true,
				});

				const parent = getParent<IUserQuizzesModel>(self, 2);
				parent.fetch();
			} finally {
				self.loading = false;
			}
		}),
	}));

export default SlideUserItem;

export interface ISlideUserItemModel extends Instance<typeof SlideUserItem> {}
export type ISlideUserItemSnapshotIn = SnapshotIn<typeof SlideUserItem>;
